import React, { PureComponent } from 'react';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import './reset.css';
import logoPic from 'images/index/logo.png';
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'
import { Message } from 'element-react';
import { Link } from 'react-router-dom';

export default class ResetPassword extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            images: [],
            phone: ''
        }
    }

    componentWillMount() {
        // 当前页刷新时获取路由参数值
        var search = this.props.location.search;
        var index = search.lastIndexOf("\=");
        var searchVal = search.substring(index + 1, search.length);
        console.log(searchVal);
        this.setState({ phone: searchVal })
    }

    handleSubmit(e){
        if(this.refs.password1.value == '' || this.refs.password2.value == ''){
            Message.error("输入不能为空");
            return false;
        }
        if(this.refs.password1.value != this.refs.password2.value){
            Message.error("两次输入密码不一致");
            return false;
        }
        
        let params = {
            phone: this.state.phone,
            resetPassword: this.refs.password2.value
        }
        return Http.post(Request.forgotPasswordAndReset(), params, obj => {
            console.log('obj', obj);
            if(obj&&obj.code == 200){
                this.props.history.replace("/success?phone=" + this.state.phone);
            }else{
                Message.error(obj.msg);
            }
            
        });
    }

    render() {
        return (
            <div>
                <GlobalHeader history={this.props.history} />
                <div className="main_reset">
                    {/* {this.renderLIst()} */}


                    {/* {内容区域*/}
                    <div className="center">
                        <div className="content">
                            <div className="content_box">
                                <div className="content_box_title">帐号安全</div>
                                <div className="content_box_change">修改密码</div>
                                <div className="content_box_account">您正在找回的账号是：<span>{this.state.phon}</span></div>
                                <div><input type="password" ref="password1" placeholder="设置密码"></input></div>
                                <div><input type="password" ref="password2" placeholder="确认密码"></input></div>
                                <div className="content_box_login" onClick={this.handleSubmit.bind(this)}><span>确定</span></div>
                            </div>
                        </div>
                    </div>

                    {/*内容区域} */}

                    <GlobalFooter />

                </div>
            </div>
        )
    }
}